import { useState, useEffect } from 'react';
import { ProfileFormHeader } from '../ProfileFormHeader';
import HalfRow from '../../../../components/formElements/HalfRow';
import FormInputField from '../../../../components/formElements/FormInputField';
import FullRow from '../../../../components/formElements/FullRow';
import useUserDetails from './hooks/useUserDetails';
import CustomRedAlert from '../../../../components/alerts/customRedAlert/CustomRedAlert';
import CustomSuccessModal from '../../../../components/alerts/customSuccessModal/CustomSuccessModal';
import { CalendarIcon, PhoneIcon, UsersIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import FormSelectDrop from '../../../../components/formElements/FormSelectDrop';
import DatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';
import { format } from 'date-fns';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import 'react-datepicker/dist/react-datepicker.css';

export default function DoctorUserDetails(props) {
    const { selectedUser, onCancel, selectionMode, onSuccessfulSave, userStatusCatalog, documentTypes } = props;

    const [openReturnAlert, setOpenReturnAlert] = useState(false);
    const [startDate, setStartDate] = useState(null);

    const {
        handleSubmit,
        register,
        errors,
        isDirty,
        closeErrorMessage,
        onCloseSuccessMessage,
        showSuccessModal,
        showErrorModal,
        errorBody,
        successBody,
        onSaveSubmit,
        documentTypesOptions,
        userStatusOptions,
        control,
        watch,
        setValue,
        getValues
    } = useUserDetails(selectedUser, onSuccessfulSave, selectionMode, userStatusCatalog, documentTypes);

    const phoneValue = watch('phone');

    useEffect(() => {
        if (selectedUser) {
            setValue('fullPhone', `${selectedUser.countryCode || ''}${selectedUser.phone || ''}`, {
                shouldDirty: true
            });
            setValue('phone', selectedUser.phone || '', { shouldDirty: true });
            setValue('countryCode', selectedUser.countryCode || '', { shouldDirty: true });
        }
    }, [selectedUser, setValue]);

    useEffect(() => {
        register('phone', {
            required: 'Este campo es requerido',
            minLength: {
                value: 8,
                message: 'Debe contener al menos 8 dígitos'
            },
            validate: (value) => /^[0-9]+$/.test(value.replace(/\+/g, '')) || 'Solo se permiten números'
        });
    }, [register]);

    if (!selectionMode) {
        return null;
    }

    const _onReturnToUsers = () => {
        if (isDirty) {
            setOpenReturnAlert(true);
        } else {
            onCancel();
        }
    };

    const _onConfirmCancelAppointment = () => {
        setOpenReturnAlert(false);
        onCancel();
    };

    const _onCancelConfirmationForClosing = () => {
        setOpenReturnAlert(false);
    };

    return (
        <form onSubmit={handleSubmit(onSaveSubmit)}>
            <div className="shadow sm:rounded-md sm:overflow-hidden">
                <div className="bg-white py-6 px-4 space-y-6 sm:p-6">
                    {selectionMode !== 'viewOnly' && <ProfileFormHeader title={'Editar datos de doctor'} />}
                    <div>
                        <h3 className="text-lg leading-6 font-medium text-dl-secondary">Detalles del doctor</h3>
                    </div>
                    <div className="grid grid-cols-6 gap-6">
                        <HalfRow>
                            <FormInputField
                                identifier="firstName"
                                label="Nombre del Doctor"
                                iconComponent={<UsersIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                                type="text"
                                registration={register('firstName', {
                                    required: 'El nombre es obligatorio',
                                    validate: (value) => {
                                        if (!value.trim()) {
                                            return 'No se permiten solo espacios';
                                        }
                                        return true;
                                    },
                                    minLength: {
                                        value: 2,
                                        message: 'Debe tener al menos 2 caracteres'
                                    },
                                    pattern: {
                                        value: /^[A-Za-zÁÉÍÓÚÑáéíóúñ\s',-]+$/,
                                        message: 'Solo se permiten letras y espacios'
                                    }
                                })}
                                errorMessage={errors.firstName?.message}
                                disabled={selectionMode === 'viewOnly'}
                            />
                        </HalfRow>

                        <HalfRow>
                            <FormInputField
                                identifier="lastName"
                                label="Apellido del Doctor"
                                iconComponent={<UsersIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                                type="text"
                                registration={register('lastName', {
                                    required: 'El apellido es obligatorio',
                                    validate: (value) => {
                                        if (!value.trim()) {
                                            return 'No se permiten solo espacios';
                                        }
                                        return true;
                                    },
                                    minLength: {
                                        value: 2,
                                        message: 'Debe tener al menos 2 caracteres'
                                    },
                                    pattern: {
                                        value: /^[A-Za-zÁÉÍÓÚÑáéíóúñ\s',-]+$/,
                                        message: 'Solo se permiten letras y espacios'
                                    }
                                })}
                                errorMessage={errors.lastName?.message}
                                disabled={selectionMode === 'viewOnly'}
                            />
                        </HalfRow>

                        {/* <HalfRow>
                            <label htmlFor="birthDate" className="block text-sm font-medium text-gray-700 mb-1">
                                Fecha de cumpleaños
                            </label>
                            <div className="relative">
                                <DatePicker
                                    id="birthDate"
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    placeholderText="Selecciona fecha"
                                    disabled={selectionMode === 'viewOnly'}
                                    dateFormat="dd/MM/yyyy"
                                    customInput={
                                        <FormInputField
                                            identifier="birthDate"
                                            iconComponent={
                                                <CalendarIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                            }
                                            registration={register('birthDate', {
                                                required: 'La fecha de nacimiento es obligatoria'
                                            })}
                                            errorMessage={errors.birthDate?.message}
                                        />
                                    }
                                />
                            </div>
                        </HalfRow> */}

                        <HalfRow>
                            <label htmlFor="birthDate" className="block text-sm font-medium text-gray-700 mb-1">
                                Fecha de cumpleaños
                            </label>
                            <div className="relative">
                                <Controller
                                    control={control}
                                    name="birthDate"
                                    rules={{ required: 'La fecha de nacimiento es obligatoria' }}
                                    render={({ field }) => (
                                        <>
                                            <input
                                                type="date"
                                                id="birthDate"
                                                value={
                                                    field.value ? new Date(field.value).toISOString().split('T')[0] : ''
                                                }
                                                onChange={(e) => {
                                                    const selectedDate = e.target.value
                                                        ? new Date(e.target.value)
                                                        : null;
                                                    if (selectedDate) {
                                                        // Full UTC ISO string with timezone (Z)
                                                        const utcDate = selectedDate.toISOString();
                                                        field.onChange(utcDate);
                                                    } else {
                                                        field.onChange('');
                                                    }
                                                }}
                                                disabled={selectionMode === 'viewOnly'}
                                                className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-dl-accent px-3 py-2"
                                            />
                                            {errors.birthDate && (
                                                <p className="mt-1 text-sm text-red-600">{errors.birthDate.message}</p>
                                            )}
                                        </>
                                    )}
                                />
                            </div>
                        </HalfRow>

                        <HalfRow>
                            <FormInputField
                                identifier="conademNumber"
                                label="Número de autorización CONADEM"
                                type="text"
                                registration={register('conademNumber', {
                                    required: 'El apellido es obligatorio',
                                    validate: (value) => {
                                        if (!value.trim()) {
                                            return 'No se permiten solo espacios';
                                        }
                                        return true;
                                    },
                                    minLength: {
                                        value: 2,
                                        message: 'Debe tener al menos 2 caracteres'
                                    },
                                    pattern: {
                                        value: /^[A-Za-zÁÉÍÓÚÑáéíóúñ0-9\s',-]+$/,
                                        message: 'Solo se permiten letras, números y espacios'
                                    }
                                })}
                                errorMessage={errors.conademNumber?.message}
                                disabled={selectionMode === 'viewOnly'}
                            />
                        </HalfRow>

                        <HalfRow>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Número de teléfono de contacto
                            </label>
                            <Controller
                                name="fullPhone"
                                control={control}
                                rules={{ required: 'Teléfono es obligatorio' }}
                                render={({ field: { onChange, value, ref } }) => {
                                    // merge existing countryCode + phone if value not set yet
                                    const mergedValue =
                                        value || `${getValues('countryCode') || ''}${getValues('phone') || ''}`;

                                    return (
                                        <PhoneInput
                                            value={mergedValue}
                                            onChange={(val, country) => {
                                                const codeVal = `+${country.dialCode}`;
                                                const phoneVal = val.replace(country.dialCode, '').replace(/^\+/, '');

                                                setValue('countryCode', codeVal);
                                                setValue('phone', phoneVal);

                                                onChange(val);
                                            }}
                                            enableSearch
                                            disableDropdown={false}
                                            disableCountryCode={false}
                                            disableAreaCodes={true}
                                            countryCodeEditable={false}
                                            placeholder="Ingrese su número"
                                            inputProps={{
                                                name: 'phone',
                                                required: true,
                                                autoFocus: false,
                                                disabled: selectionMode === 'viewOnly',
                                                ref
                                            }}
                                            inputClass={`form-input block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm
            ${errors.phone ? 'border-red-500' : ''}`}
                                            containerClass="w-full"
                                        />
                                    );
                                }}
                            />

                            {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone.message}</p>}
                        </HalfRow>

                        <HalfRow>
                            <FormInputField
                                identifier="email"
                                label="Dirección de email"
                                iconComponent={<EnvelopeIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                                type="string"
                                registration={register('email', {
                                    required: 'El correo es obligatorio',
                                    pattern: {
                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                        message: 'Correo no válido'
                                    }
                                })}
                                errorMessage={errors.email?.message}
                                disabled
                            />
                        </HalfRow>

                        <HalfRow>
                            <FormInputField
                                identifier="secondary_email"
                                label="Correo electrónico secundario"
                                iconComponent={<EnvelopeIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                                type="string"
                                registration={register('secondary_email', {
                                    required: 'El correo secundario es obligatorio',
                                    pattern: {
                                        value: /^(?!\.)[A-Za-z0-9._%+-]+(?<!\.)@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                                        message: 'Correo no válido'
                                    }
                                })}
                                errorMessage={errors.secondary_email?.message}
                            />
                        </HalfRow>

                        <HalfRow>
                            <FormSelectDrop
                                label="Tipo de Documento"
                                identifier="idDocumentTypes"
                                options={documentTypesOptions}
                                defaultValue={selectedUser.idDocumentTypes}
                                defaultOption={false}
                                helperText="Requerido"
                                registration={register('idDocumentTypes', {
                                    required: 'Este campo es obligatorio'
                                })}
                                errorMessage={errors.idDocumentTypes?.message}
                            />
                        </HalfRow>

                        <HalfRow>
                            <FormInputField
                                identifier="personalDocument"
                                label="Número de documento"
                                type="string"
                                registration={register('personalDocument', {
                                    required: 'Número de documento obligatorio',
                                    minLength: { value: 6, message: 'Debe tener al menos 6 caracteres' }
                                })}
                                errorMessage={errors.personalDocument?.message}
                                disabled={selectionMode === 'viewOnly'}
                            />
                        </HalfRow>

                        <HalfRow>
                            <FormInputField
                                identifier="creation"
                                label="Creación"
                                type="string"
                                registration={register('creation', {
                                    required: 'Campo obligatorio'
                                })}
                                errorMessage={errors.creation?.message}
                                disabled
                            />
                        </HalfRow>

                        <HalfRow>
                            <FormSelectDrop
                                label="Estado del usuario"
                                identifier="idDoctorUserStatus"
                                options={userStatusOptions}
                                defaultValue={selectedUser.idDoctorUserStatus}
                                defaultOption={false}
                                helperText="Requerido"
                                registration={register('idDoctorUserStatus', {
                                    required: 'Este campo es obligatorio'
                                })}
                                errorMessage={errors.idDoctorUserStatus?.message}
                            />
                        </HalfRow>
                    </div>
                </div>
                <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                    {/*<button
                        type="button"
                        onClick={onCancel}
                        className="bg-dl-red border border-transparent rounded-full shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-dl-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dl-red"
                    >
                        Cerrar
                    </button>*/}
                    <button
                        type="button"
                        onClick={_onReturnToUsers}
                        className="mr-2 rounded-full border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-dl-accent focus:ring-offset-2"
                    >
                        Regresar
                    </button>
                    {selectionMode === 'edit' && (
                        <button
                            type="submit"
                            disabled={!isDirty}
                            className="disabled:bg-dl-primary-700 bg-dl-primary-900 border border-transparent rounded-full shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-dl-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dl-primary-700"
                        >
                            Actualizar Datos
                        </button>
                    )}
                </div>
            </div>

            {openReturnAlert && (
                <CustomRedAlert
                    open={openReturnAlert}
                    title={'¿Desea descartar los cambios?'}
                    bodyText={'La cita ha sido modificada, por favor confirme que desea salir de esta vista.'}
                    onClose={_onCancelConfirmationForClosing}
                    mainActionText={'Salir'}
                    onMainAction={_onConfirmCancelAppointment}
                    secondaryActionText={'Cancelar'}
                    onSecondaryAction={_onCancelConfirmationForClosing}
                />
            )}

            {showErrorModal && (
                <CustomRedAlert
                    open={showErrorModal}
                    title={'Ocurrió un error.'}
                    bodyText={errorBody}
                    onClose={closeErrorMessage}
                />
            )}

            {showSuccessModal && (
                <CustomSuccessModal
                    title={'Registro actualizado con éxito'}
                    bodyText={successBody}
                    buttonText={'Aceptar'}
                    buttonAction={onCloseSuccessMessage}
                    open={showSuccessModal}
                    onClose={onCloseSuccessMessage}
                />
            )}
        </form>
    );
}
